import React, { Component } from 'react';
import { Layout } from 'antd';
import TopNavHeader from '@/components/TopNavHeader';
class Header extends Component {
    render() {
        const { className, style, menuData, contentWidth, sso, currentRoute, } = this.props;
        return (<Layout.Header className={className} style={Object.assign({ padding: '0' }, style)}>
        <TopNavHeader sso={sso} menuData={menuData} contentWidth={contentWidth} currentRoute={currentRoute}/>
      </Layout.Header>);
    }
}
export default Header;
